import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import './PlaceOrderDialog.css';

function PlaceOrderDialog({ isOpen, onClose, cartItems, onPlaceOrder, submitting = false, maxTables = null }) {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    tableNumber: ''
  });
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear validation once user edits.
    if (error) setError('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (submitting) return;

    const parsedTable = Number(formData.tableNumber);
    if (!Number.isInteger(parsedTable) || parsedTable < 1) {
      setError('Please enter a valid table number (minimum 1).');
      return;
    }

    if (maxTables && parsedTable > maxTables) {
      setError(`Please enter a valid table number (1-${maxTables}).`);
      return;
    }

    onPlaceOrder({
      ...formData,
      tableNumber: parsedTable,
    });
  };

  if (!isOpen) return null;

  const total = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);

  return (
    <div className="dialog-overlay">
      <div className="dialog order-dialog">
        <button className="close-button" onClick={onClose} aria-label="Close" disabled={submitting}>
          <FaTimes />
        </button>
        
        <div className="dialog-content">
          <h2 className="dialog-title">Place Your Order</h2>
          
          <form onSubmit={handleSubmit} className="order-form">
            {error ? <div className="dialog-error">{error}</div> : null}
            <div className="form-group">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Your Name"
                required
                className="form-input"
                disabled={submitting}
              />
            </div>
            
            <div className="form-group">
              <input
                type="tel"
                name="mobile"
                value={formData.mobile}
                onChange={handleInputChange}
                placeholder="Mobile Number"
                required
                pattern="[0-9]{10}"
                title="Please enter a valid 10-digit mobile number"
                className="form-input"
                disabled={submitting}
              />
            </div>
            
            <div className="form-group">
              <input
                type="number"
                min="1"
                max={maxTables || undefined}
                name="tableNumber"
                value={formData.tableNumber}
                onChange={handleInputChange}
                placeholder={maxTables ? `Table Number (1-${maxTables})` : 'Table Number'}
                required
                className="form-input"
                disabled={submitting}
              />
            </div>
            
            <div className="order-summary">
              <h3 className="summary-title">Order Summary</h3>
              {cartItems.map((item) => (
                <div key={item.id} className="order-item">
                  <span className="item-name">{item.name} × {item.quantity}</span>
                  <span className="item-price">{item.price * item.quantity}</span>
                </div>
              ))}
              
              <div className="total-section">
                <div className="grand-total">
                  <span>Total Amount:</span>
                  <span>₹{total}</span>
                </div>
              </div>
            </div>
            
            <button type="submit" className="place-order-btn" disabled={submitting}>
              {submitting ? 'Placing Orders…' : 'Place All Orders'}
            </button>

            {submitting ? (
              <div className="place-order-wait-note" role="status" aria-live="polite">
                Placing your orders… please wait.
              </div>
            ) : null}
          </form>
        </div>
      </div>
    </div>
  );
}

export default PlaceOrderDialog;
